<div *ngIf="bloqueada" class="loading-overlay">
    <i class="bn-loading-spinner"></i>
</div>
